import useGetDetailItem from "@hooks/Faq/useGetFaq";
import formMapper from "@mappers/Modules/faq/FaqItem.mapper";
import updateItem from "@services/Faq/updateFaq";
import Modify from "@shared/FormTemplates/Modify";
import validator from "@validators/Modules/faq/faq.validate";
import { ReactElement } from "react";
import ModifyForm from "./ModifyForm";

const ModifyItem = (): ReactElement => (
  <Modify
    CustomForm={ModifyForm}
    modifyHook={updateItem}
    detailHook={useGetDetailItem}
    validator={validator}
    formMapper={formMapper}
  />
);

export default ModifyItem;
